import { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import { useWarehousesQuery } from "../../../services/warehouseApi";
import { signInUser } from "../../Utility/Auth";
import customStyles from "./SelectFeild";

const WareHouseDWPurchase = ({ wh, handleOnChange, name, id, defaultFirst = false }) => {
  const auth = signInUser();
  const aamarId = auth?.aamarId;
  const { data, error, isLoading, isFetching, isSuccess } = useWarehousesQuery(
    { aamarId },
    { skip: !aamarId }
  );
  let [warehouseOption, setWarehouseOption] = useState([]);

  useEffect(() => {
    if (isSuccess && data && Array.isArray(data) && data.length > 0) {
      const warehouseOptions = data.map((warehouse) => ({
        value: warehouse._id,
        option: warehouse._id,
        label: `${warehouse.name} - [ ${warehouse.address} ]`,
      }));
      setWarehouseOption(warehouseOptions);
    }
  }, [data, isSuccess]);

  const selectedValue =
    wh && warehouseOption.length > 0
      ? warehouseOption.find((opt) => opt.option === wh || opt.value === wh) || null
      : defaultFirst && warehouseOption.length > 0
      ? warehouseOption[0]
      : null;

  return (
    <Fragment>
      <Select
        id={id}
        className="basic-single"
        classNamePrefix="select"
        placeholder="Select warehouse"
        value={selectedValue}
        getOptionLabel={(opt) => opt.label}
        getOptionValue={(opt) => opt.option || opt.value}
        isDisabled={false}
        isLoading={isLoading || isFetching}
        isClearable={false}
        isSearchable={true}
        name={name}
        onChange={handleOnChange}
        options={warehouseOption}
        styles={customStyles}
      />
    </Fragment>
  );
};

export default WareHouseDWPurchase;
